import { views as admin } from '../features/admin/views.js';
import { Akun, Menu } from '../features/akun/Akun.js';
import { views as data } from '../features/data/views.js';
import { views as driver } from '../features/driver/views.js';
import { views as nota } from '../features/nota/views.js';
import { views as panduan } from '../features/panduan/views.js';
import { views as spo } from '../features/spo/views.js';
import { lazyView } from './lazyView.js';
import { TITLES } from './nav.js';
import type { ViewComponent } from './Shell.js';
import { useView } from './view.js';

// Daftar layar → komponen, digabung dari tiap kelompok fitur (features/<kelompok>/views.ts).
// Layar dimuat terpisah (lazy) agar HP hanya mengunduh yang dipakai perannya.

function NotYet() {
  const { r } = useView();
  return (
    <div className="card">
      <div className="empty">Layar “{TITLES[r.view] || r.view}” belum dipindah ke versi 2.</div>
    </div>
  );
}

const ALL_VIEWS = Object.keys(TITLES);

export const VIEWS: Record<string, ViewComponent> = {
  // Selama Fase 3: layar yang belum dipindah menampilkan NotYet.
  ...Object.fromEntries(ALL_VIEWS.map((v) => [v, NotYet])),
  akun: Akun,
  menu: Menu,
  // Portal toko (pilot)
  'toko-home': lazyView(() => import('../features/toko/TokoHome.js')),
  pesan: lazyView(() => import('../features/toko/Pesan.js')),
  pesanan: lazyView(() => import('../features/toko/Pesanan.js')),
  lacak: lazyView(() => import('../features/toko/Lacak.js')),
  ...spo,
  ...nota,
  ...driver,
  ...admin,
  ...data,
  ...panduan,
};
